import { Component } from '@verndale/core';
import { ReplaceHeading, ConditionalDisplay } from '../helpers/global';

class JobOverview extends Component {
  setupDefaults() {
    this.dom = {
      heading: this.el.querySelector<HTMLElement>('.v-section-heading')
    };

    if (ConditionalDisplay(this.el.id)) {
      this.el.style.display = 'none';
    }
    if (this.dom.heading) {
      ReplaceHeading(this.dom.heading as HTMLElement);
    }
  }
}

export default JobOverview;
